module.exports = __webpack_public_path__ + "img/ico_pica.82f34daf.svg";